import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Login from 'Pages/Login/Login'; // adjust path

const hasAuthToken = (token: string | null): boolean => Boolean(token);

const AuthRoute = ({ instance }) => {
  const location = useLocation();
  const token = localStorage.getItem('token');
  const msalUsername = localStorage.getItem('msalUsername');
  // Two independent login paths (email/password JWT and Azure MSAL SSO) both
  // grant access — SSO never receives a backend JWT, so it's tracked separately.
  const isValid = hasAuthToken(token) || Boolean(msalUsername);

  if (location.pathname === '/auth/response-oidc') {
    return <Outlet />;
  }

  const isAuthEntryPath = location.pathname === '/';

  if (isAuthEntryPath) {
    if (isValid) {
      return <Navigate to="/projects" replace />;
    } else {
      return <Login instance={instance}/>;
    }
  }

  if (!isValid) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default AuthRoute;
